/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FaChevronCircleRight } from '@react-icons/all-files/fa/FaChevronCircleRight';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import Button from 'gatsby-core-theme/src/components/atoms/button';
import { Context } from '~context/MainProvider';
import FeaturedMatch from '../../../atoms/featured-match';
import styles from './match-card.module.scss';

/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-danger */

const MatchCard = ({ item, isStorybook = false }) => {
  const { translations } = useContext(Context) || {};
  return (
    <div className={styles.matchCard}>
      <FeaturedMatch type="soccer" context="cards" item={item} isStorybook={isStorybook} />
      <div className={styles.description}>
        {item.description ? (
          <div
            className={styles.descriptionText}
            dangerouslySetInnerHTML={{ __html: item.description }}
          />
        ) : (
          <p className={styles.descriptionText}>
            {`${item?.home_team?.name} ${translate(translations, 'meets', 'meets')} ${
              item?.away_team?.name
            } ${translate(translations, 'at_home_on', 'at home on')} ${item?.date?.day_number}. `}
            <span className={styles.month}>{item?.date?.month_short}</span>
            {` ${item?.date?.year_number} `}
            <span className={styles.at}>{translate(translations, 'at', 'at')}</span>
            {` ${item?.date?.time}
          ${translate(
            translations,
            'in_the_match_for_3_points_in_this_exciting',
            'in the match for 3 points in this exciting'
          )}
          ${item?.tournament?.name} ${translate(translations, 'match', 'match')}. 
          ${translate(
            translations,
            'follow_the_match_live_-_watch_here',
            'Follow the match live - watch here'
          )}.`}
          </p>
        )}
        <a className={`${styles.articleLink} match-card-gtm`} href={item?.path}>
          {translate(translations, 'read_the_entire_article_here', 'Read the entire article here')}
          &nbsp;&gt;&gt;
        </a>
      </div>
      <Button
        to={item?.path}
        className="soccer"
        isInternalLink
        btnText={
          <>
            <FaChevronCircleRight />
            {translate(translations, 'watch_live_online', 'Watch live online')}
          </>
        }
        gtmClass="match-card-gtm btn-cta"
      />
    </div>
  );
};

MatchCard.propTypes = {
  item: PropTypes.shape({
    path: PropTypes.string,
    description: PropTypes.string,
    home_team: PropTypes.shape({
      name: PropTypes.string,
    }),
    away_team: PropTypes.shape({
      name: PropTypes.string,
    }),
    tournament: PropTypes.shape({
      name: PropTypes.string,
    }),
    date: PropTypes.shape({
      day_number: PropTypes.number,
      month_short: PropTypes.string,
      year_number: PropTypes.number,
      time: PropTypes.string,
    }),
  }),
  isStorybook: PropTypes.bool,
};

export default MatchCard;
